
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/889b590529c93e79ba5a281a2d38735a.jpg"
          alt="Rastrek Rastreamento"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          O Melhor Rastreamento<br />do Mercado
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
          Monitoramento 24h, corte de combustível e acompanhamento pelo app. Proteja seu veículo com tecnologia de ponta.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToContact}
            className="bg-yellow-500 text-black px-10 py-4 rounded-lg text-lg font-bold hover:bg-yellow-400 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Solicitar Instalação
          </button>
          <a
            href="#beneficios"
            className="bg-white/10 backdrop-blur-sm text-white px-10 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            Conhecer Benefícios
          </a>
        </div>
        
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-24-hours-line text-2xl text-black"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2">Monitoramento 24h</h3>
            <p className="text-white/80 text-sm">Segurança total o tempo todo</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-gas-station-line text-2xl text-black"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2">Corte de Combustível</h3>
            <p className="text-white/80 text-sm">Bloqueio remoto instantâneo</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-smartphone-line text-2xl text-black"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-2">App Completo</h3>
            <p className="text-white/80 text-sm">Controle na palma da mão</p>
          </div>
        </div>
      </div>
    </section>
  );
}
